import React, { FC } from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';
import { UserAllRegistrations } from '../../../shared/user/base';
import { PageHeader, UserRoute, UserStateComponent } from '../../components';
import { useTranslation } from '../../translations';
import { Fetcher, isLogicError, useFetcher } from '../../utils';
import { LogicError } from '../../utils/errorHandling';
import { RegistrationClosed } from './RegistrationClosed';
import { EditRegistration } from './edit';
import { RegistrationList } from './list';
import { NewRegistration } from './new';

export const RegistrationWrapper: FC = () => {
  const { ts } = useTranslation();
  const { path } = useRouteMatch();

  const request = useFetcher<UserAllRegistrations>(async () => {
    return await api.getActiveRegistrations();
  }, []);

  if (!request.success) {
    if (request.error && isLogicError(request.error, LogicError.RegistrationClosed)) {
      return <RegistrationClosed />;
    }

    return <Fetcher result={request} />;
  }

  return (
    <UserStateComponent>
      <PageHeader>{ts('event_registration')}</PageHeader>
      <Switch>
        <UserRoute
          exact
          path={`${path}/register`}
          render={() => (
            <RegistrationList allRegistrations={request.data} refresh={request.refresh} />
          )}
        />
        <UserRoute component={NewRegistration} exact path={`${path}/register/new`} />
        <UserRoute
          exact
          path={`${path}/register/edit`}
          render={() => <EditRegistration allRegistrations={request.data} />}
        />
        <UserRoute
          exact
          path={`${path}/register/edit/:id`}
          render={() => <EditRegistration allRegistrations={request.data} />}
        />
      </Switch>
    </UserStateComponent>
  );
};
